<template>
  <div :class="$style.si">
    <svg
      viewBox="0 0 48 48"
      width="64"
      height="64"
      aria-hidden="true"
    >
      <path
        :class="$style['si-trace']"
        d="M17.5 17.5 L30.5 30.5"
        pathLength="1"
      ></path>
      <path
        :class="$style['si-trace2']"
        d="M30.5 17.5 L17.5 30.5"
        pathLength="1"
      ></path>
    </svg>
  </div>
</template>

<style
  lang="scss"
  module
>
.si {
  width: 64px;
  height: 64px;
  --mark: var(--error-base);
  --si-dur: 3s;
  border-radius: 50%;
  display: grid;
  place-items: center;
  flex: none;
  position: relative;
}

.si svg {
  display: block;
  overflow: visible;
}

.si-trace,
.si-trace2 {
  fill: none;
  stroke: var(--mark);
  stroke-width: 3;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 1;
}

.si-trace {
  animation: si-trace var(--si-dur) 1 forwards;
}

.si-trace2 {
  animation: si-trace2 var(--si-dur) 1 forwards;
}

@keyframes si-trace {
  0% {
    stroke-dashoffset: 1;
    animation-timing-function: cubic-bezier(.6, 0, .2, 1);
  }
  30% {
    stroke-dashoffset: 0;
    animation-timing-function: linear;
  }
  70% {
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes si-trace2 {
  0%,
  12% {
    stroke-dashoffset: 1;
    animation-timing-function: cubic-bezier(.6, 0, .2, 1);
  }
  40% {
    stroke-dashoffset: 0;
    animation-timing-function: linear;
  }
  70% {
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .si-trace,
  .si-trace2 {
    stroke-dasharray: none;
    animation: none;
  }
}
</style>
